export default __webpack_public_path__ + "static/media/arrow.175a9bec.gif";